import { put, select } from 'redux-saga/effects';
import { demandLastRequestedData, demandRequestCreateMessageStartAction } from '@cian/demand-trap-widget';
import { ICreateMessageRequest } from '../../repositories/demand/v2/create-message';

export function* verifyPhoneRetrySendingSms() {
  const demandData: ICreateMessageRequest = yield select(demandLastRequestedData);

  delete demandData.confirmationCode;

  yield put(demandRequestCreateMessageStartAction(demandData));
}
